import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, FormGroup } from 'react-bootstrap';
import { Toggle, PaymentMethodIcon } from 'components/utilities';

const getFieldErrors = (cardType, errors, validityErrors) => {
  const ERRMSG_NUMBER_EMPTY = 'A credit card number is required';
  const ERRMSG_NUMBER_INVALID = 'That credit card number appears to be incorrect';
  const ERRMSG_EXPDATE_EMPTY = 'Expiration is required';
  const ERRMSG_EXPDATE_INVALID = 'Expiration appears invalid';
  const ERRMSG_CVV_EMPTY = 'CVV is required';
  const ERRMSG_CVV_INVALID = 'CVV is invalid';
  const ERRMSG_POSTAL_CODE = 'Postal code is invalid';

  const fieldErrors = {};

  if (errors) {
    const { code } = errors;

    if (code === 'HOSTED_FIELDS_FIELDS_EMPTY') {
      fieldErrors.number = ERRMSG_NUMBER_EMPTY;
      fieldErrors.expirationDate = ERRMSG_EXPDATE_EMPTY;
      fieldErrors.cvv = ERRMSG_CVV_EMPTY;
      fieldErrors.postalCode = ERRMSG_POSTAL_CODE;
    } else if (code === 'HOSTED_FIELDS_FIELDS_INVALID') {
      const invalidFieldKeys = _.get(errors, 'details.invalidFieldKeys');

      if (_.includes(invalidFieldKeys, 'number')) {
        fieldErrors.number = ERRMSG_NUMBER_EMPTY;
      }
      if (_.includes(invalidFieldKeys, 'expirationDate')) {
        fieldErrors.expirationDate = ERRMSG_EXPDATE_EMPTY;
      }
      if (_.includes(invalidFieldKeys, 'cvv')) {
        fieldErrors.cvv = ERRMSG_CVV_EMPTY;
      }
      if (_.includes(invalidFieldKeys, 'postalCode')) {
        fieldErrors.postalCode = ERRMSG_POSTAL_CODE;
      }
    }
  }

  if (validityErrors.number) {
    fieldErrors.number = ERRMSG_NUMBER_INVALID;
  }
  if (validityErrors.expirationDate) {
    fieldErrors.expirationDate = ERRMSG_EXPDATE_INVALID;
  }
  if (validityErrors.cvv) {
    fieldErrors.cvv = ERRMSG_CVV_INVALID;
  }
  if (validityErrors.postalCode) {
    fieldErrors.postalCode = ERRMSG_POSTAL_CODE;
  }

  if (cardType === 'american-express') {
    fieldErrors.number = "Sorry, we don't accept American Express";
  }

  return fieldErrors;
};

const CCForm = (props) => {
  const { cardType, errors, validityErrors } = props;

  const fieldErrors = getFieldErrors(cardType, errors, validityErrors);

  return (
    <div className="m-t-2">
      <FormGroup validationState={fieldErrors.number ? 'error' : null}>
        <Row>
          <Col sm={8}>

            <div id="number" className="form-control" />

            {cardType ? (
              <PaymentMethodIcon
                icon={cardType}
                size={36}
              />
            ) : null}

            <Toggle show={!_.isEmpty(fieldErrors.number)}>
              <span className="help-block text-danger m-l-1">{fieldErrors.number}</span>
            </Toggle>

          </Col>
        </Row>
      </FormGroup>

      <Row className="m-t-neg-1">
        <Col sm={3}>
          <FormGroup validationState={fieldErrors.expirationDate ? 'error' : null}>
            <div id="expirationDate" className="form-control" />
            <Toggle show={!_.isEmpty(fieldErrors.expirationDate)}>
              <span className="help-block text-danger m-l-1">{fieldErrors.expirationDate}</span>
            </Toggle>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup validationState={fieldErrors.cvv ? 'error' : null}>
            <div id="cvv" className="form-control" />
            <Toggle show={!_.isEmpty(fieldErrors.cvv)}>
              <span className="help-block text-danger m-l-1">{fieldErrors.cvv}</span>
            </Toggle>
          </FormGroup>
        </Col>

        <Col sm={3}>
          <FormGroup validationState={fieldErrors.postalCode ? 'error' : null}>
            <div id="postalCode" className="form-control" />
            <Toggle show={!_.isEmpty(fieldErrors.postalCode)}>
              <span className="help-block text-danger m-l-1">{fieldErrors.postalCode}</span>
            </Toggle>
          </FormGroup>
        </Col>
      </Row>

      {_.has(errors, 'donation._') && (
        <FormGroup validationState="error">
          <span className="help-block text-danger m-l-1">
            {_.get(errors, 'donation._.0')}
          </span>
        </FormGroup>
      )}

      <hr />

    </div>
  );
};

const { object, string } = PropTypes;

CCForm.propTypes = {
  cardType: string,
  validityErrors: object.isRequired,
  errors: object,
};

export default CCForm;
